<template>

  <v-card v-if="agent" @click="itemClicked" class="agent-card">
    <v-card-title class="py-2">
      {{ agentName }}
    </v-card-title>

    <v-card-text>
      <div style="color:#9c9c9c;">FA license #</div>
      <div style="font-size:20px;">{{ agentFaCardNumber }}</div>
      <div class="mt-6 image-container">
        <img id="img" style="max-width:50%;max-height:275px;" :src="savedFaCard"  />
      </div>
    </v-card-text>
  </v-card>

</template>

<script>
export default {
  name: 'AgentCard',

  props: {
    agent: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      savedFaCard: null
    }
  },

  computed: {
    agentName () {
      return this.agent.receiving_agent_name
    },
    agentFaCardNumber () {
      return this.agent.receiving_agent_fa_license_number
    },
    isAgentCardSaved () {
      return this.agent.receiver_card_saved_at
    }
  },

  async beforeMount () {
    // Load agent FA card
    if (this.isAgentCardSaved) await this.loadSavedFaCard()
  },

  methods: {
    itemClicked () {
      this.$emit('itemClicked', this.agent)
    },

    async loadSavedFaCard () {
      const agentFaCardImage = await this.$root.fetchOrderAsset(this.agent.id, 'agent_fa_license')
      this.savedFaCard = agentFaCardImage
    }
  }
}
</script>

<style>
  .agent-card .image-container {
    border: 1px solid #525252;
    border-radius: 8px;
    padding: 4px 0 0 0;
    min-height: 150px;
    text-align: center;
  }
</style>
